/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  (function($) {
    $.QueryString = (function(a) {
      var b, i, p;
      if (a === '') {
        return {};
      }
      b = {};
      i = 0;
      while (i < a.length) {
        p = a[i].split('=');
        if (p.length !== 2) {
          ++i;
          continue;
        }
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
        ++i;
      }
      return b;
    })(window.location.search.substr(1).split('&'));
  })(jQuery);

}).call(globalThis);
